import { render, staticRenderFns } from "./TasksList.vue?vue&type=template&id=2f14c43b&scoped=true"
import script from "./TasksList.vue?vue&type=script&lang=js"
export * from "./TasksList.vue?vue&type=script&lang=js"
import style0 from "./TasksList.vue?vue&type=style&index=0&id=2f14c43b&prod&lang=scss&scoped=true"
import style1 from "./TasksList.vue?vue&type=style&index=1&id=2f14c43b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f14c43b",
  null
  
)

export default component.exports